import Vue from "vue";

/**
 * 模糊查询品牌
 * @param params
 * @returns {*}
 */
export function brandLikeQuery(params) {
    return Vue.axios({
        url: '/api/brand/query',
        method: 'get',
        params
    })
}

/**
 * 品牌分页列表
 * @param params
 * @returns {*}
 */
export function brandPage(params) {
    return Vue.axios({
        url: '/api/brand/page',
        method: 'get',
        params
    })
}

/**
 * 品牌保存
 * @param data
 * @returns {*}
 */
export function brandStore(data) {
    return Vue.axios({
        url: '/api/brand/store',
        method: 'post',
        data
    })
}

/**
 * 品牌删除
 * @param data
 * @returns {*}
 */
export function brandDelete(data) {
    return Vue.axios({
        url: '/api/brand/delete',
        method: 'post',
        data
    })
}

/**
 * 品牌集团保存
 * @param data
 * @returns {*}
 */
export function storeCombine(data) {
    return Vue.axios({
        url: '/api/brand/storeCombine',
        method: 'post',
        data
    })
}

export function storeTag(data) {
    return Vue.axios({
        url: '/api/brand/storeTag',
        method: 'post',
        data
    })
}

export function brandOption() {
    return Vue.axios({
        url: '/api/brand/option',
        method: 'post',
    })
}